import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconGoods = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_25171_34129",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_25171_34129)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.33398 5.26982H9.16598H8.73782H8.95832H3.33398ZM3.59432 4.26998H12.4007L11.6737 3.40448C11.6523 3.38315 11.6278 3.36604 11.6 3.35315C11.5722 3.34037 11.5434 3.33398 11.5135 3.33398H4.48148C4.4516 3.33398 4.42271 3.34037 4.39482 3.35315C4.36704 3.36604 4.34248 3.38315 4.32115 3.40448L3.59432 4.26998ZM6.66732 8.57115L8.00065 7.90448L9.33398 8.57115V5.26982H6.66732V8.57115ZM9.52748 13.6673H3.53915C3.20771 13.6673 2.92398 13.5493 2.68798 13.3133C2.45198 13.0773 2.33398 12.7936 2.33398 12.4622V4.67115C2.33398 4.5306 2.35687 4.39504 2.40265 4.26448C2.44832 4.13393 2.51687 4.01393 2.60832 3.90448L3.54432 2.77248C3.65365 2.63137 3.79037 2.52304 3.95448 2.44748C4.1186 2.37182 4.29243 2.33398 4.47598 2.33398H11.5125C11.696 2.33398 11.8707 2.37182 12.0363 2.44748C12.2021 2.52304 12.3402 2.63137 12.4507 2.77248L13.393 3.91732C13.4844 4.02854 13.553 4.14982 13.5987 4.28115C13.6444 4.41248 13.6673 4.54893 13.6673 4.69048V7.57882C13.516 7.52671 13.3592 7.48698 13.1968 7.45965C13.0344 7.43232 12.8707 7.41865 12.7058 7.41865H12.6673V5.26982H10.334V8.26215C10.0775 8.41604 9.84654 8.61093 9.64098 8.84682C9.43543 9.08271 9.2771 9.33782 9.16598 9.61215L8.00065 9.03265L5.66732 10.1993V5.26982H3.33398V12.4622C3.33398 12.522 3.35321 12.5712 3.39165 12.6097C3.4301 12.6481 3.47926 12.6673 3.53915 12.6673H8.95832C9.02265 12.8573 9.10304 13.0349 9.19948 13.2002C9.29593 13.3654 9.40526 13.5211 9.52748 13.6673ZM12.1993 13.866V11.866H10.1993V10.866H12.1993V8.86598H13.1993V10.866H15.1993V11.866H13.1993V13.866H12.1993Z",
			fill: "#959595"
		})
	})]
});
export default SvgIconGoods;
